/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventTypeEnum } from './EventTypeEnum';
import {
    EventTypeEnumFromJSON,
    EventTypeEnumFromJSONTyped,
    EventTypeEnumToJSON,
    EventTypeEnumToJSONTyped,
} from './EventTypeEnum';

/**
 * 
 * @export
 * @interface EventCreate
 */
export interface EventCreate {
    /**
     * Type of event (e.g., 'FILING', 'HEARING', 'SETTLEMENT', 'JUDGMENT')
     * @type {EventTypeEnum}
     * @memberof EventCreate
     */
    eventType: EventTypeEnum;
    /**
     * Title of the event
     * @type {string}
     * @memberof EventCreate
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventCreate
     */
    fullContent?: string | null;
    /**
     * Date of the event (format: YYYY-MM-DD)
     * @type {Date}
     * @memberof EventCreate
     */
    eventDate: Date;
    /**
     * URL of the litigation release from which this event was extracted
     * @type {string}
     * @memberof EventCreate
     */
    sourceUrl: string;
    /**
     * 
     * @type {number}
     * @memberof EventCreate
     */
    prosecutionId: number;
}



/**
 * Check if a given object implements the EventCreate interface.
 */
export function instanceOfEventCreate(value: object): value is EventCreate {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('eventDate' in value) || value['eventDate'] === undefined) return false;
    if (!('sourceUrl' in value) || value['sourceUrl'] === undefined) return false;
    if (!('prosecutionId' in value) || value['prosecutionId'] === undefined) return false;
    return true;
}

export function EventCreateFromJSON(json: any): EventCreate {
    return EventCreateFromJSONTyped(json, false);
}

export function EventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': EventTypeEnumFromJSON(json['event_type']),
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'fullContent': json['full_content'] == null ? undefined : json['full_content'],
        'eventDate': (new Date(json['event_date'])),
        'sourceUrl': json['source_url'],
        'prosecutionId': json['prosecution_id'],
    };
}

export function EventCreateToJSON(json: any): EventCreate {
    return EventCreateToJSONTyped(json, false);
}

export function EventCreateToJSONTyped(value?: EventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_type': EventTypeEnumToJSON(value['eventType']),
        'title': value['title'],
        'description': value['description'],
        'full_content': value['fullContent'],
        'event_date': ((value['eventDate']).toISOString().substring(0,10)),
        'source_url': value['sourceUrl'],
        'prosecution_id': value['prosecutionId'],
    };
}

